import {now} from "@atg-shared/datetime";
import atgFetch from "@atg-shared/fetch";
import {FETCH, call} from "@atg-shared/fetch-redux";
import {BIG9_OFFERING_API_URL} from "@atg-shared/service-url";
import {OfferingStatus} from "@atg-sport-shared/pool-types/offeringTypes";
import {MarketUtils} from "@atg-tillsammans-shared/utils";

import type {AtgResponse, FetchAction} from "@atg-shared/fetch-types";
import type {Offering} from "@atg-sport-shared/pool-types/offeringTypes";

export const REQUEST_SPORT_JACKPOT = "jackpot/REQUEST_SPORT_JACKPOT";
export const RECEIVE_SPORT_JACKPOT = "jackpot/RECEIVE_SPORT_JACKPOT";
export const RESET_JACKPOT = "jackpot/RESET_JACKPOT";

export type SportOfferingFetchAction = FetchAction<
    typeof REQUEST_SPORT_JACKPOT,
    typeof RECEIVE_SPORT_JACKPOT,
    ReadonlyArray<Offering>
>;

export type Action = SportOfferingFetchAction;

export const fetchSportJackpot = (): SportOfferingFetchAction => ({
    type: FETCH,
    payload: {
        requestAction: REQUEST_SPORT_JACKPOT,
        receiveAction: RECEIVE_SPORT_JACKPOT,
        callApi: call(
            (): Promise<AtgResponse<Array<Offering>>> =>
                atgFetch<Array<Offering>>(
                    `${BIG9_OFFERING_API_URL}?status=${Object.values(OfferingStatus).join(
                        ",",
                    )}&fromDate=${now().subtract(5, "weeks").format("YYYY-MM-DD")}`,

                    {
                        headers: MarketUtils.getMarketHeaders(),
                    },
                ),
        ),
    },
});
